import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Button, UncontrolledTooltip, Input } from "reactstrap";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { Option } from "src/models/components/inputWrapperModel";
import {
  Columns,
  LazyTableState,
} from "src/models/components/dataTableWrapperModel";
import DataTableWrapper from "src/components/Grid/DataTableWrapper";
import { DataTable, DataTableFilterMeta } from "primereact/datatable";
import { useDispatch, useSelector } from "react-redux";
import ColumnAction from "src/components/Common/ColumnAction/ColumnAction";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../Calendar/DeleteModal";
import ArchiveModal from "../../Calendar/DeleteModal";
import { useToast } from "src/components/Common/ReactToaster";
import Select from "src/components/Common/Select";
import { audioBrands } from "src/models/pages/audioBrandsModel";
import { RootReducerState } from "src/store/reducers";
import { ROUTER } from "src/constants/routes";
import { CurrencyFormatter, formatDateMEL, saveAsExcelFile } from "src/helpers/common_helpers";
import { MultiSelectChangeEvent } from "primereact/multiselect";
import FeatherIcon from "feather-icons-react";
import CustomizeTable from "src/components/Common/CustomizeTable/CustomizeTable";
import { getStockRegisterList } from "src/store/stockRegister/action";
import SortIcon from "src/components/Common/CustomFilterandSortIcon/SortIcon";
import FilterIcon from "src/components/Common/CustomFilterandSortIcon/FilterIcon";
import ExportFile from "src/components/Common/ExcelPdf Export/ExportFile";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Link } from "react-router-dom";
import { API } from "src/util/api";
import { customizeTableColumns } from "src/models/components/CustomizeTableColumns";


const stockRegisterListConversation = (values: any) => {
  const modifeidValue = values?.items?.map((eachValue: any) => {
    let data: any = {};
    data['id'] = eachValue?.id;
    data['partSkuNumber'] = eachValue?.partSkuNumber;
    data['reference'] = "";
    data['stockAdjustment'] = eachValue?.stockAdjusment;
    data['brandName'] = eachValue?.brandName;
    data['partNumber'] = eachValue?.partNumber;
    data['partDescription'] = eachValue?.partDescription;
    data['partHsnNumber'] = eachValue?.partHsnNumber;
    data['partBuyingPrice'] = eachValue?.partBuyingPrice;
    data['partTaxPercentage'] = eachValue?.partTaxPercentage;
    data['partPrice'] = eachValue?.partPrice;
    data['event'] = eachValue?.event;
    data['to'] = eachValue?.to;
    data['eventDate'] = formatDateMEL(eachValue?.creationTime)
    data['month'] = eachValue?.month;
    data['year'] = eachValue?.year;
    data['name'] = eachValue?.name;
    data['poNumber'] = eachValue?.poNumber;
    data['audioBrandIds']=eachValue?.audioBrandId
    data['partIds']=eachValue?.partId;
    data['SupplierId']=eachValue?.supplierId
    data['puchaseOrderId']=eachValue?.puchaseOrderId;
    data['partSkuId']=eachValue?.partSkuId;
    data['locationName']=eachValue?.locationName;
    return data;
  });
  return modifeidValue;
};

export default function StockRegisterList() {
  const navigate = useNavigate();
  const [filter, setFilter] = useState(false);
  const { values, totalRecords } = useSelector((state: RootReducerState) => state.stockRegisterReducer.stockRegister);
  const modifiedValues = stockRegisterListConversation(values)
  const { showToast } = useToast();
  const { loading } = useSelector((state: RootReducerState) => state.stockRegisterReducer);
  const[pdfLoading,setPdfLoading]=useState<boolean>(false)

  const { error, message } = useSelector((state: RootReducerState) => state.stockRegisterReducer);
  const dispatch = useDispatch();
  const dt = useRef<DataTable<any>>(null);
  // for delete invoice
  const [deleteModal, setDeleteModal] = useState(false);
  const [archiveModal, setArchiveModal] = useState(false);
  const [rowData, setRowData] = useState<audioBrands | null>(null);
  const filterDetails: DataTableFilterMeta = {
    partSkuNumber: { value: "", matchMode: "contains" },
    brandName: { value: "", matchMode: "contains" },
    partDescription: { value: "", matchMode: "contains" },
    poNumber: { value: "", matchMode: "contains" },
    name: { value: "", matchMode: "contains" },
    to: { value: "", matchMode: "contains" },
    eventDate: { value: "", matchMode: "contains" },
    IsDeleted: { value: "false", matchMode: "contains" },
    EventStartDate: { value: "", matchMode: "contains" },
    EventEndDate: { value: "", matchMode: "contains" },
    CreationTime: { value: "", matchMode: "contains" },
  };
  let initialLazyState: LazyTableState = {
    first: 0,
    rows: 10,
    page: 1,
    // sortField: "",
    // sortOrder: 0,
    sortField: "CreationTime",
    sortOrder: -1,
    filters: filterDetails,
  };
  const [lazyState, setLazyState] = useState<any>(initialLazyState);

  const initialValues = {
    status: "",
  };
  const onFilterClickHandler = () => {
    setFilter((preState) => !preState);
  };
  const onCreateClickHandler = () => {
    navigate(ROUTER.STOCK_ADJUSTMENT_CREATE);
  };

  const viewHandler = (rowData: audioBrands) => {
    navigate(`${ROUTER.STOCK_ADJUSTMENT_VIEW}/${rowData["id"]}`);
  };
  const editHandler = (rowData: audioBrands) => {
    navigate(`${ROUTER.STOCK_ADJUSTMENT_EDIT}/${rowData["id"]}`);
  };
  const deleteHandler = (rowData: audioBrands) => {
    setDeleteModal(true);
    setRowData(rowData);
  };

  const actionBodyTemplate = (rowData: audioBrands, field: string) => {
    return (
      <ColumnAction
        displayData={rowData[field] as string}
      />
    );
  };

  const options: Option[] = [
    { label: "Active", value: "Active" },
    { label: "Inactive", value: "Inactive" },
  ];

  const dateFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
    return (<>
      <label htmlFor="">Start Date</label>
      <Input type="date" required value={options?.value?.startDate || ""} max={options?.value?.endDate ? options?.value?.endDate : ""} onChange={(e: any) => {
        options
        let modifiedDate: any = options.value || { startDate: "", endDate: "" }
        modifiedDate['startDate'] = e.target.value
        options.filterCallback(modifiedDate, options.index);
      }} />
      <br />
      <label htmlFor="">End Date</label>
      <Input type="date" required value={options?.value?.endDate || ""} min={options?.value?.startDate ? options?.value?.startDate : ""} onChange={(e: any) => {
        options
        let modifiedDate: any = options.value || { startDate: "", endDate: "" }
        modifiedDate['endDate'] = e.target.value
        options.filterCallback(modifiedDate, options.index);
      }} />
    </>)
  };

  const currencyBodyTemplate = (rowData: any, field: string) => {
    let amount = rowData[field];
    return (<>{CurrencyFormatter({ value: amount })}</>);
  };
  const percentageBodyTemplate = (rowData: any, field: string) => {
    return (
      <div>{rowData[field] + ' %'}</div>
    );
  };

  const AudioBrandTemplate = (rowData: any, field: any) => {
    
    return (
      <Link to={`${ROUTER.AUDIO_BRANDS_VIEW}/${rowData['audioBrandIds']}`}>{rowData[field]}</Link>
    )
  }
  const ReferenceTemplate = (rowData: any, field: any) => {
    let status = rowData['to']
    if(status == "Used" ){
      return (
        <Link to={`${ROUTER.INVOICE_VIEW_BY_PART + `/${rowData?.partSkuId}`}`}>{"Invoice"}</Link>
      )
    }else if(status == "Scrapped" || status == "Rejected" || status == "Missing"){
      return (
        <Link to={`${ROUTER.STOCK_ADJUSTMENT_PART_VIEW + `/${rowData?.partSkuId}` }`}>{"Stock Adjustment"}</Link>
      )
    }else{
      return(<></>)
    }

    
  }

  const partTemplate = (rowData: any, field: any) => {
    
    return (
      <Link to={`${ROUTER.PARTS_VIEW}/${rowData['partIds']}`}>{rowData[field]}</Link>
    )
  }

  const supplierBodyTemplate = (rowData: any, field: string) => {
    return (
      <Link to={`${ROUTER.SUPPLIER_VIEW}/${rowData['SupplierId']}`}>{rowData[field]}</Link>
    );
  };

  const PurchaseOrderTemplate = (rowData: any, field: string) => {
    return (
      <Link to={`${ROUTER.PURCHASE_ORDER_VIEW}/${rowData['puchaseOrderId']}`}>{rowData[field]}</Link>
    );
  };

  const headerTemplate =(val:any)=>{
    return(
      <div className="d-flex justify-content-center">
        <div className="d-flex justify-content-end"style={{width:"100px"}}  >
        <div className="align-right">
          {val}
        </div>
        </div>
      </div>
    )
    }
    
  const columns: Columns[] = [
    // {
    //   field: "select",
    //   sortable: false,
    //   header: "",
    //   filter: false,
    //   showFilterMenu: false,
    //   selectionMode: "multiple",
    //   headerStyle: { width: "3rem", whiteSpace: "nowrap" },
    //   isDefault: true,
    //   isStatic: false,
    // },
    {
      field: "partSkuNumber",
      sortable: true,
      header: "Part Sku Number",
      filter: true,
      showFilterMenu: true,
      frozen : true,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: true,
    },
    {
      field: "reference",
      sortable: false,
      header: "References",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      body: (rowData: any) => ReferenceTemplate(rowData, 'reference'),
      isDefault: true,
      isStatic: false,
    },
    // {
    //   field: "stockAdjustment",
    //   sortable: false,
    //   header: "Stock Adjustment",
    //   filter: false,
    //   showFilterMenu: false,
    //   headerStyle: { whiteSpace: "nowrap" },
    //   isDefault: true,
    //   isStatic: false,
    // },
    {
      field: "brandName",
      sortable: true,
      header: "Audio Brand",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap" },
      body: (rowData: any) => AudioBrandTemplate(rowData, 'brandName'),
      isDefault: true,
      isStatic: false,
    },
    {
      field: "partNumber",
      sortable: true,
      header: "Part",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      body:(rowData:any)=>partTemplate(rowData,'partNumber'),
      isDefault: true,
      isStatic: false,
    },
    {
      field: "partDescription",
      sortable: true,
      header: "Part Description",
      filter: true,
      showFilterMenu: true,
      isDefault: true,
      isStatic: false,
    },
    {
      field: "locationName",
      sortable: false,
      header: "Location",
      filter: false,
      showFilterMenu: false,
      isDefault: true,
      isStatic: false,
    },
    {
      field: "partHsnNumber",
      sortable: true,
      header: "Part HSN Number",
      filter: false,
      showFilterMenu: false,
      isDefault: false,
      isStatic: false,
    },
    {
      field: "partBuyingPrice",
      sortable: true,
      header: "Part Buying Price",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      body: (rowData) => headerTemplate(currencyBodyTemplate(rowData, 'partBuyingPrice')),
      isDefault: true,
      isStatic: false,
    },
    {
      field: "partTaxPercentage",
      sortable: true,
      header: "Part Tax Percentage",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: false,
      body: (rowData) => headerTemplate(percentageBodyTemplate(rowData, "partTaxPercentage")),
    },
    {
      field: "partPrice",
      sortable: true,
      header: "Part Price",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: false,
      body: (rowData) => headerTemplate(currencyBodyTemplate(rowData, 'partPrice')),
    },
    {
      field: "event",
      sortable: true,
      header: "Event",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: false,
    },
    {
      field: "to",
      sortable: true,
      header: "Part Sku Status",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: false,
    },
    {
      field: "eventDate",
      sortable: true,
      header: "Event Date",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap" },
      body: (rowData) => formatDateMEL(rowData.eventDate),
      filterElement: dateFilterTemplate,
      isDefault: true,
      isStatic: false
    },
    {
      field: "month",
      sortable: true,
      header: "Event Month",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      body:(rowData:any)=>headerTemplate(rowData.month),
      isDefault: true,
      isStatic: false,
    },
    {
      field: "year",
      sortable: true,
      header: "Event Year",
      body:(rowData:any)=>headerTemplate(rowData.year),
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: false,
    },
    {
      field: "name",
      sortable: true,
      header: "Supplier",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap" },
      body:(rowData:any)=>supplierBodyTemplate(rowData,'name'),
      isDefault: true,
      isStatic: false,
    }, {
      field: "poNumber",
      sortable: true,
      header: "Purchase Order",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap" },
      body:(rowData:any)=>PurchaseOrderTemplate(rowData,'poNumber'),
      isDefault: true,
      isStatic: false,
    },
  ];

  const [visibleColumns, setVisibleColumns] = useState(columns.filter((eachColumn: Columns) => eachColumn.isDefault));


  const changeColumnDetails = (values: any[]) => {
    let modifiedColumnDetails = values.map((eachPurchase) => {
      const { partSkuNumber, brandName: AudioBrand, partNumber, partDescription, partHsnNumber, partBuyingPrice, partTaxPercentage, partPrice, event, to: partSKUStatus, eventDate, month, year, name: suplierName, poNumber: purchaseOrder, invoice: Invoice, stockAdjustment } = eachPurchase;
      let data: any = {};
      data['part sku Number'] = partSkuNumber;
      data['Stock Adjustment'] = stockAdjustment;
      data["part"] = partNumber;
      data["part Description"] = partDescription;
      data["part HsnNumber"] = partHsnNumber;
      data["part Buying Price"] = partBuyingPrice;
      data["part Tax Percentage"] = partTaxPercentage;
      data["part Price"] = partPrice;
      data["event"] = event;
      data["part sku Status"] = partSKUStatus;
      data["event Date"] = eventDate;
      data["event Month"] = month;
      data["event Year"] = year;
      return { ...{ AudioBrand, suplierName, purchaseOrder, Invoice }, ...data };
    });
    return modifiedColumnDetails;
  };

  const saveDataAsExcel = (values: any[], fileName: string) => {
    const modifiedColumnDetails = changeColumnDetails(values)
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(modifiedColumnDetails);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });
      saveAsExcelFile(excelBuffer, fileName);
    });
  };
  const fetchData = async (isPdf:boolean) => {
    let state:any= {
      ...lazyState,
      rows:totalRecords>5000 ? 5000 : totalRecords<1 ? 1 : totalRecords,
      first:0,
      filters: {
        ...lazyState.filters,
      },
    };
    
    try {
      setPdfLoading(true)
      const response = await API.getStockRegisterListAPI(state);
      if (!response) {
        throw new Error('Network response was not ok');
      }
      const modifeidValue = response?.data?.items?.map((eachValue: any) => {
        let data: any = {};
        data['id'] = eachValue?.id;
        data['partSkuNumber'] = eachValue?.partSkuNumber;
        data['reference'] = "";
        data['stockAdjustment'] = eachValue?.stockAdjusment;
        data['brandName'] = eachValue?.brandName;
        data['partNumber'] = eachValue?.partNumber;
        data['partDescription'] = eachValue?.partDescription;
        data['partHsnNumber'] = eachValue?.partHsnNumber;
        data['partBuyingPrice'] = eachValue?.partBuyingPrice;
        data['partTaxPercentage'] = eachValue?.partTaxPercentage;
        data['partPrice'] = eachValue?.partPrice;
        data['event'] = eachValue?.event;
        data['to'] = eachValue?.to;
        data['eventDate'] = formatDateMEL(eachValue?.creationTime)
        data['month'] = eachValue?.month;
        data['year'] = eachValue?.year;
        data['name'] = eachValue?.name;
        data['poNumber'] = eachValue?.poNumber;
        data['audioBrandIds']=eachValue?.audioBrandId
        data['partIds']=eachValue?.partId;
        data['SupplierId']=eachValue?.supplierId
        data['puchaseOrderId']=eachValue?.puchaseOrderId;
        data['partSkuId']=eachValue?.partSkuId;
        data['locationName']=eachValue?.locationName;
        data['reference']=eachValue?.to=="Used" ? `Invoice (${eachValue?.partSkuId})` : (eachValue?.to == "Scrapped" || eachValue?.to == "Rejected" || eachValue?.to == "Missing") ? `Stock Adjustment (${eachValue?.partSkuId})` : "";
        return data;
      });
      
      // let resp=await stockRegisterListConversation(response?.data?.items)
     if(isPdf){

       saveDataAsPdf(modifeidValue, columns, "Stock Register");
     }else{
      saveDataAsExcel(modifeidValue, "Stock Register");
     }
     setPdfLoading(false)
    } catch (error) {
      setPdfLoading(false)
      
    } finally {
      setPdfLoading(false)
    }
  };
  const csvClickHandler = () => {
    // saveDataAsExcel(modifiedValues, "Stock Register");
    fetchData(false)
  };

  const saveDataAsPdf = (values: any[], columns: any[], fileName: string) => {
    const destructureedData = values.map((data) => {
      let datas = {
        partSkuNumber: data.partSkuNumber,
        stockAdjustment: data.stockAdjustment,
        brandName: data.brandName,
        part: data.part,
        partDescription: data.partDescription,
        partHsnNumber: data.partHsnNumber,
        partBuyingPrice: data.partBuyingPrice,
        partTaxPercentage: data.partTaxPercentage,
        partPrice: data.partPrice,
        event: data.event,
        to: data.to,
        eventDate: data.eventDate,
        eventMonth: data.eventMonth,
        eventYear: data.eventYear,
        name: data.name,
        poNumber: data.poNumber,
        reference:data.reference
      };
      return datas;
    });
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const exportColumns = columns.map((col) => ({
          title: col.header,
          dataKey: col.field,
        }));
        // const doc = new (jsPDF as any).default(0, 0);
        const doc = new (jsPDF as any).default({
          orientation: 'landscape',
          format: 'a3',
          useCss: true,
          theme: "striped",
          showHead: "everyPage",
          columns: exportColumns,
          body: modifiedValues,
          showFoot: "everyPage",
          tableWidth: "auto",
        });
        doc.autoTable(exportColumns, destructureedData);
        doc.save(`${fileName}.pdf`);
      });
    });
  };


  const pdfClickHandler = () => {
    // saveDataAsPdf(modifiedValues, columns, "Stock Register");
    fetchData(true)
  };

  const validationSchema = Yup.object({});

  const callbackFunction = (lazyState: LazyTableState) => {
    let modifiedLazyState: any = { ...lazyState };
    if (modifiedLazyState.filters && modifiedLazyState.filters.eventDate) {
      modifiedLazyState.filters.eventDate.value = "";
    }
    dispatch(getStockRegisterList(lazyState));
  };

  const [selectAll, setSelectAll] = useState(false);
  const [selectedStockAdjustment, setSelectedStockAdjustment] = useState<any>([]);

  const onSelectionChange = (event: any) => {
    const value = event.value;
    setSelectedStockAdjustment(value);
    setSelectAll(value.length === totalRecords);
  };

  const onSelectAllChange = (event: any) => {
    const selectAll = event.checked;

    if (selectAll) {
      setSelectAll(true);
      setSelectedStockAdjustment(values);
    } else {
      setSelectAll(false);
      setSelectedStockAdjustment([]);
    }
  };

  const handleStatusBlur = () => { };

  const onPage = (event: any) => {
    setLazyState(event);
  };

  const onSort = (event: any) => {

    setLazyState(event);
  };

  const onFilter = (event: any) => {
    event["first"] = 0;
    event['filters']['EventStartDate']['value'] = event?.filters?.eventDate?.value?.startDate ? event?.filters?.eventDate?.value?.startDate : ''
    event['filters']['EventEndDate']['value'] = event?.filters?.eventDate?.value?.endDate ? event?.filters?.eventDate?.value?.endDate : ''
    setLazyState(event);
  };

  const handleSubmit = (formValue: any) => {
    setLazyState((state: any) => ({
      ...state,
      filters: {
        ...state.filters,
        status: {
          ...state.filters.status,
          value: formValue["status"],
        }

      },
    }));
  };

  const handleReset = (formValue: any) => {
    setLazyState((state: any) => ({
      ...state,
      filters: {
        ...state.filters,
        status: {
          ...state.filters.status,
          value: "",
        }
      },
    }));
  };

  useEffect(() => {
    let data: any = { ...lazyState };
    if (data.sortField == "eventDate") {
      data.sortField = "creationTime"
    }
    callbackFunction(data);
  }, [lazyState]);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (error) {
      setVisible(true);
      // showToast(error, { type: "error" })
    }
    if (message) {
      showToast(message, { type: "success" });
      // dispatch(clearPartsMessage());
    }
  }, [error, message]);

  const handleDeleteUsers = (rowData: audioBrands) => {
    let payload = {
      id: rowData["id"],
      lazyState,
    };
    // dispatch(deleteStockAdjustmentFromList(payload));
    setDeleteModal(false);
    setRowData(null);
    showToast("Stock Adjustment Successfully", { type: "success" });
  };

  const archiveHandler = () => {
    setSelectAll(false);
    setSelectedStockAdjustment([]);
    setArchiveModal(false);
  };
  const defaultColumns = {
    ...columns[0]
  }

  const onColumnToggle = (event: MultiSelectChangeEvent) => {
    let selectedColumns = event.value;
    let orderedSelectedColumns = columns.filter((col) => selectedColumns.some((sCol: any) => sCol.field === col.field));

    setVisibleColumns([...orderedSelectedColumns]);
  };
  const [showCustomizeTable, setShowCustomizeTable] = useState(false);
  const customizeTableClickHandler = () => {
    setShowCustomizeTable(true);
  };


  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);
  const [selectedStatus, setselectedStatus] = useState(null);


  const bulkActionClickHandler = () => {
    // if (values.length > 0) {
    //   setSelectAll(true);
    //   setSelectedStockAdjustment(values);
    // }
  };
  const cancelBulkActionHadler = () => {
    setSelectAll(false);
    setSelectedStockAdjustment([]);
  };
  useEffect(() => {
    const preloader: any = document.getElementById("preloader");
    if (loading||pdfLoading) {
      preloader.style.display = "block";
    } else {
      preloader.style.display = "none";
    }
  }, [loading,pdfLoading]);

  const clearFilter=()=>{
    setLazyState(initialLazyState)
  }

  const header =
    <div className="table-header-container">
      {/* <BreadcrumbWithFilter
        title="Admin"
        breadcrumbItem="Stock Register"
        isShowFilter={false}
        isShowCreate={false}
        selectedCustomers={selectedStockAdjustment}
        bulkActionSatusTitle="Stock Register"
      /> */}
      <div>Stock Register</div>
      <div className="table-header-container-item">
        {/* {selectedStockAdjustment.length == 0 && <Button type="button" className="customize-table-button mr-1 " onClick={bulkActionClickHandler}>
        <FeatherIcon icon="layers" className="mr-1" />
        Bulk actions
      </Button>} */}
        {/* <AnimatePresence>
          {selectedStockAdjustment.length > 0 &&
            <>
              <motion.div initial="initial" animate="animate" exit="exit" variants={BUTTON_VARIANT}>
            <Button type="button" className="secondary-btn  mr-1" onClick={() => { setArchiveModal(true); }}>
              <FeatherIcon icon="archive" className="mr-1" />
              Archive
            </Button>
          </motion.div>
              <motion.div initial="initial" animate="animate" exit="exit" variants={BUTTON_VARIANT}>
            <Button type="button" className="secondary-btn  mr-1" onClick={() => { setDeleteModal(true); }}>
              <FeatherIcon icon="trash-2" className="mr-1" />
              Delete
            </Button>
          </motion.div>
              <motion.div initial="initial" animate="animate" exit="exit" variants={BUTTON_VARIANT}>
                <Button type="button" className="customize-table-button mr-1 ml-1" onClick={cancelBulkActionHadler} > <FeatherIcon icon="x" className="" /> Cancel selection</Button>
              </motion.div>

              <motion.div initial="initial" animate="animate" exit="exit" variants={BUTTON_VARIANT}>
                {selectedStockAdjustment.length > 0 && <BulkActionStatus count={selectedStockAdjustment.length} title="Stock Registers"></BulkActionStatus>}
              </motion.div>

            </>
          }
        </AnimatePresence> */}

      </div>
      <div className="flex-grow-1"></div>
      <div className="table-header-container-item">
        <ExportFile exportExcel={csvClickHandler} exportPdf={pdfClickHandler} TooltipPosition="left" clearFilter={clearFilter} isFilter={true} />
        {/* <TooltipMEL title="Select Status" position="bottom">
          <Dropdown value={selectedStatus} onChange={(e) => handleSubmit(e.value)} options={options} optionLabel="label" placeholder="Select status .."
            filter className="w-full md:w-14rem" />
        </TooltipMEL> */}
        <Button type="button" className="customize-table-button mt-1" id="ScheduleUpdateTooltip"
          onMouseEnter={() => setTooltipOpen(true)}
          onMouseLeave={() => setTooltipOpen(false)} data-btn="btn" onClick={customizeTableClickHandler}  style={{paddingLeft:"0px"}}>
          <FeatherIcon icon="sliders"/>
        </Button>

        {/* <Button type="button" className="btn btn-primary" onClick={onCreateClickHandler}>
        <FeatherIcon icon="plus-circle" style={{ marginRight: "10px" }} />
        Add Stock Register
      </Button> */}

        <UncontrolledTooltip
          placement="bottom"
          target="ScheduleUpdateTooltip"
          isOpen={tooltipOpen}
          toggle={toggleTooltip}
          innerClassName="tooltip-color"
        >
          Choose fields you want to see in the table
        </UncontrolledTooltip>
      </div>

    </div>;

  const customizeTableCancelHandler = () => {
    setShowCustomizeTable(false);
  };
  const customizeColumnSubmitHandler = (customizeColumnObject: any[]) => {
    let orderedSelectedColumns = columns.filter((col) => customizeColumnObject.some((sCol: any) => sCol === col.field));

    setVisibleColumns([...orderedSelectedColumns]);
    setShowCustomizeTable(false);
  };
  const customizeTableColumns: customizeTableColumns[] = columns.map((eachColumns: Columns) => {
    let data: any = {};
    data['field'] = eachColumns.field;
    data['value'] = visibleColumns.some((sCol: any) => sCol.field === eachColumns.field);
    data['isDisable'] = eachColumns.isStatic;
    data['header'] = eachColumns.header;
    return data;
  }).filter((eachColumns: customizeTableColumns) => eachColumns.field != 'select');

  return (
    <>
      <div className="page-content" id="stock-music-system">
        <DeleteModal
          show={deleteModal}
          onDeleteClick={() => {
            if (rowData) {
              handleDeleteUsers(rowData);
            }
          }}
          onCloseClick={() => {
            setDeleteModal(false);
            setRowData(null);
          }}
        />
        <ArchiveModal
          show={archiveModal}
          message="you want to archieve these audio brands?"
          deleteLabel="Yes"
          closeLabel="No"
          onDeleteClick={() => {
            archiveHandler();
          }}
          onCloseClick={() => {
            setArchiveModal(false);
            setSelectAll(false);
            setSelectedStockAdjustment([]);
          }}
        />
        {showCustomizeTable && <CustomizeTable onCancelHandler={customizeTableCancelHandler} onCustomizeColumnSubmitHandler={customizeColumnSubmitHandler} columns={customizeTableColumns} />}

        {filter && (
          <div className="card">
            <div className="card-body">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                onReset={handleReset}
                enableReinitialize
              >
                {({ values, handleChange }) => {
                  return (
                    <Form onChange={handleChange}>
                      <Row>
                        <Col xs={12} lg={7} id="export-search-clear">

                        </Col>
                        <Col xs={12} lg={5} id="export-search-clear d-flex">
                          <Select
                            label=""
                            name="status"
                            onBlur={handleStatusBlur}
                            value={values.status}
                            onChange={handleChange}
                            options={options}
                            invalid={false}
                          />
                          <Button className="btn btn-primary ms-2" color="primary" type="reset">
                            Clear </Button>
                          <Button className="btn btn-primary ms-2" color="primary" type="submit">
                            Search </Button>
                        </Col>


                      </Row>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        )}
        <DataTableWrapper
          ref={dt}
          header={header}
          columnDetails={visibleColumns}
          value={modifiedValues}
          lazy
          paginator={true}
          stripedRows={true}
          rowHover={true}
          filterIcon={FilterIcon}
          // filterDisplay="row"
          sortIcon={(setOrder) => <SortIcon order={setOrder} />}
          rowsPerPageOptions={[5, 10, 25, 50]}
          totalRecords={totalRecords}
          loading={loading}
          emptyMessage="No Stock Register Found."
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Displaying Stock Register  {last} records of {totalRecords} in total"
          selection={selectedStockAdjustment}
          onSelectionChange={onSelectionChange}
          selectAll={selectAll}
          onSelectAllChange={onSelectAllChange}
          first={lazyState.first}
          onSort={onSort}
          sortField={lazyState.sortField}
          sortOrder={lazyState.sortOrder}
          onFilter={onFilter}
          filters={lazyState.filters}
          onPage={onPage}
          rows={lazyState.rows}
        ></DataTableWrapper>
      </div>
    </>
  );
}
